module.exports = __webpack_public_path__ + "static/media/check-double-asterisk.d9147f2d.svg";